import { render } from "./CharactersDrawer.vue?vue&type=template&id=71714c73&scoped=true"
import script from "./CharactersDrawer.vue?vue&type=script&lang=js"
export * from "./CharactersDrawer.vue?vue&type=script&lang=js"

import "./CharactersDrawer.vue?vue&type=style&index=0&id=71714c73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71714c73"]])

export default __exports__